import angular from 'angular';
import uiRouter from 'angular-ui-router';
import stCookieSettingsComponent from './stCookieSettings.component';

let stCookieSettingsModule = angular.module('stCookieSettings', [
  uiRouter
])

.component('stCookieSettings', stCookieSettingsComponent)
.name;

export default stCookieSettingsModule;



// WEBPACK FOOTER //
// ./client/app/common/stCookieSettings/stCookieSettings.js